import { render, staticRenderFns } from "./UpdateSkuRateHistoryDialog.vue?vue&type=template&id=ee3f80c6"
import script from "./UpdateSkuRateHistoryDialog.vue?vue&type=script&lang=js"
export * from "./UpdateSkuRateHistoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports